import {
    SpacingToken,
    UiStack,
    UiText,
} from '@experiences/ui-common';
import {
    Card,
    CardActionArea,
    CardContent,
} from '@mui/material';
import { FontVariantToken } from '@uipath/apollo-core';
import { ApBadge } from '@uipath/portal-shell-react';
import React from 'react';
import { useIntl } from 'react-intl';

export interface StepCardProps {
    label: string;
    title: string;
    description: string;
    icon: React.ReactNode;
    status?: 'default' | 'info' | 'success';
    dataCy?: string;
}

export const GovernancePolicyCreateStepCard: React.FC<StepCardProps & {
    isSelected: boolean;
    onClick: () => void;
    height?: string;
    dataCy?: string;
}> = ({
    label,
    title,
    description,
    icon,
    status = 'default',
    isSelected,
    onClick,
    height = '170px',
    dataCy,
}) => {
    const { formatMessage: translate } = useIntl();
    return (
        <Card
            elevation={0}
            data-cy={dataCy ?? 'governance-policy-step-card'}
            sx={{
                height,
                border: '1px solid',
                borderColor: 'var(--color-foreground-de-emp)',
            }}>
            <CardActionArea
                onClick={onClick}
                data-active={isSelected ? '' : undefined}
                data-cy="governance-policy-step-card-action"
                sx={{ height: '100%' }}
            >
                <CardContent sx={{
                    height: '100%',
                    p: 3,
                }}>
                    <UiStack
                        direction="column"
                        align="start"
                        gap={SpacingToken.M}
                        h="100%">
                        <ApBadge
                            label={translate({ id: label })}
                            status={status}
                            size="small"
                            data-cy="governance-policy-step-card-badge"
                        />
                        <UiStack
                            direction="row"
                            gap={SpacingToken.XS}>
                            <UiStack
                                direction="row"
                                align="center"
                                ml="auto">
                                {icon}
                            </UiStack>
                            <UiStack
                                direction="column"
                                grow={1}
                                justify="center">
                                <UiText
                                    variant={FontVariantToken.fontSizeLBold}
                                    data-cy="governance-policy-step-card-title">
                                    {translate({ id: title })}
                                </UiText>
                                <UiText
                                    variant={FontVariantToken.fontSizeS}
                                    data-cy="governance-policy-step-card-description"
                                    style={{ color: 'var(--color-foreground-de-emp)' }}>
                                    {translate({ id: description })}
                                </UiText>
                            </UiStack>
                        </UiStack>
                    </UiStack>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};
